import { AppIcon } from './AppIcon.tsx';

/** Ein Eintrag zum Abhaken, zum Beispiel eine Zutat oder ein Gerät. */
export function CheckItem({
  label,
  sub,
  checked,
  onToggle,
}: {
  readonly label: string;
  readonly sub?: string;
  readonly checked: boolean;
  readonly onToggle: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onToggle}
      className={`flex w-full items-center gap-3 rounded-xl border p-3 text-left ${
        checked ? 'border-accent bg-accent-soft' : 'border-border-subtle bg-surface-raised'
      }`}
    >
      <span
        className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full border ${
          checked ? 'border-accent bg-accent text-on-accent' : 'border-border-subtle'
        }`}
      >
        {checked ? <AppIcon name="check" size={14} /> : null}
      </span>
      <span className="min-w-0">
        <span className={`block ${checked ? 'text-content-muted line-through' : ''}`}>{label}</span>
        {sub === undefined ? null : <span className="block text-xs text-content-muted">{sub}</span>}
      </span>
    </button>
  );
}
